import { render, staticRenderFns } from "./dashboard-sales-admin.vue?vue&type=template&id=babc7aa4&scoped=true&"
import script from "./dashboard-sales-admin.vue?vue&type=script&lang=js&"
export * from "./dashboard-sales-admin.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-sales-admin.vue?vue&type=style&index=0&id=babc7aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babc7aa4",
  null
  
)

export default component.exports